import { CommonDT, PageQueryParams, RestResponse } from "./CommonDT";
import { _get, _post, _req } from "../../request";

export type termsDataType = CommonDT & {
  termUuid: string;
  termIncId: number;
  termName: string;
  termTaxonomy: string;
  termSlug: string;
  termDesc: string;
  termIcon: string;
  termBgUrl: string;
  termLevel: number;
  termPath: string;
  fkUpperTermUuid: string;
};

export type TermsNodeListDT = termsDataType & {
  termsNodeList: TermsNodeListDT[];
};

/**
 * ==========================================================
 * ========================公共接口===========================
 * ==========================================================
 */
const get = async (id: any): Promise<RestResponse> => {
  return await _get("/cnt/terms/get/", id);
};

const page = async (data: PageQueryParams): Promise<RestResponse> => {
  return await _post("/cnt/terms/page", data);
};

const saveBatch = async (dataList: termsDataType): Promise<RestResponse> => {
  return await _post("/cnt/terms/saveBatch", dataList);
};

const alterBatch = async (dataList: termsDataType): Promise<RestResponse> => {
  return await _post("/cnt/terms/alterBatch", dataList);
};

const removeBatch = async (idList: string[]): Promise<RestResponse> => {
  return await _post("/cnt/terms/removeBatch", idList);
};

/**
 * ==========================================================
 * ========================特有接口===========================
 * ==========================================================
 */
const other = async (params: {}, body: {}): Promise<RestResponse> => {
  return await _req("/cnt/terms/other", "POST", params, body);
};
const treeTerm = async (
  params: { parentTermId?: string, termTaxonomy?: string },
  body: {}
): Promise<RestResponse> => {
  return await _req("/cnt/terms/treeTerm", "GET", params, body);
};

const termsApi = {
  get,
  page,
  saveBatch,
  alterBatch,
  removeBatch,
  other,
  treeTerm,
};

export default termsApi;
